import { useState } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { AccordionTransition } from 'foundations-components/transitional/components/AccordionTransition';
import { Box } from 'foundations-components/transitional/components/Box';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Small } from 'foundations-components/transitional/components/Small';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { useUpdateEmaIssuerUrl } from '../../../hooks/mutations/useUpdateEmaIssuerUrl';
import { isValidHttpsUrl } from '../../../utils/urls';
import { EnterpriseManagedAuthAccountId } from './EnterpriseManagedAuthAccountId';
import { EnterpriseManagedAuthPanel } from './EnterpriseManagedAuthPanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EnterpriseManagedAuthActive({
  accountId,
  issuerUrl
}) {
  const [draftIssuerUrl, setDraftIssuerUrl] = useState(issuerUrl);
  const [isEditing, setIsEditing] = useState(false);
  const {
    updateIssuerUrl,
    loading,
    error
  } = useUpdateEmaIssuerUrl();
  const trimmedIssuerUrl = draftIssuerUrl.trim();
  const hasIssuerUrlError = trimmedIssuerUrl !== '' && !isValidHttpsUrl(trimmedIssuerUrl);
  const canSave = trimmedIssuerUrl !== '' && !hasIssuerUrlError && trimmedIssuerUrl !== issuerUrl;
  const handleCancel = () => {
    setDraftIssuerUrl(issuerUrl);
    setIsEditing(false);
  };
  const handleSave = () => void updateIssuerUrl(trimmedIssuerUrl).then(({
    data
  }) => {
    if (data) {
      setIsEditing(false);
    }
  });
  return /*#__PURE__*/_jsxs(EnterpriseManagedAuthPanel, {
    statusTagUse: "success",
    statusLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app-governance-lib.advanced.ema.active.status"
    }),
    children: [/*#__PURE__*/_jsx(EnterpriseManagedAuthAccountId, {
      value: accountId,
      label: I18n.text('app-governance-lib.advanced.ema.active.accountId.label')
    }), /*#__PURE__*/_jsxs(Box, {
      children: [/*#__PURE__*/_jsx(FormControl, {
        verticalSeparation: "flush",
        label: I18n.text('app-governance-lib.advanced.ema.active.issuerUrl.label'),
        error: hasIssuerUrlError,
        validationMessage: hasIssuerUrlError ? I18n.text('app-governance-lib.advanced.ema.active.issuerUrl.invalid') : undefined,
        children: /*#__PURE__*/_jsx(TextInput, {
          value: draftIssuerUrl,
          onChange: e => setDraftIssuerUrl(e.target.value),
          onFocus: () => setIsEditing(true),
          readOnly: loading
        })
      }), /*#__PURE__*/_jsx(AccordionTransition, {
        open: isEditing,
        children: /*#__PURE__*/_jsxs(ButtonWrapper, {
          paddingBlock: "200",
          children: [/*#__PURE__*/_jsx(LoadingButton, {
            use: "primary",
            loading: loading,
            failed: Boolean(error),
            disabled: !canSave,
            onClick: handleSave,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app-governance-lib.advanced.ema.active.issuerUrl.save"
            })
          }), /*#__PURE__*/_jsx(Button, {
            use: "secondary",
            onClick: handleCancel,
            disabled: loading,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app-governance-lib.advanced.ema.active.issuerUrl.cancel"
            })
          })]
        })
      })]
    }), /*#__PURE__*/_jsx(Small, {
      color: "text-core-subtle",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app-governance-lib.advanced.ema.active.note"
      })
    })]
  });
}